const USER_TYPES = {
  USER: 'USER',
  HISTORIAN: 'HISTORIAN',
  FUNCTIONARY: 'FUNCTIONARY',
  NOTARY: 'NOTARY',
  NOTARY_DPJ: 'NOTARY_DPJ',
  COMMERCIAL_REGISTER: 'COMMERCIAL_REGISTER',
  FUNCTIONARY_ORGANIZATION: 'FUNCTIONARY_ORGANIZATION',
  ONAT_USER: 'ONAT_USER',
};

const USER_TYPES_ENUM = Object.keys(USER_TYPES);

const USER = USER_TYPES_ENUM[0];
const HISTORIAN = USER_TYPES_ENUM[1];
const FUNCTIONARY = USER_TYPES_ENUM[2];
const NOTARY = USER_TYPES_ENUM[3];
const NOTARY_DPJ = USER_TYPES_ENUM[4];
const COMMERCIAL_REGISTER = USER_TYPES_ENUM[5];
const FUNCTIONARY_ORGANIZATION = USER_TYPES_ENUM[6];
const ONAT_USER = USER_TYPES_ENUM[7];

export {
  USER_TYPES,
  USER_TYPES_ENUM,
  USER,
  HISTORIAN,
  FUNCTIONARY,
  NOTARY,
  NOTARY_DPJ,
  COMMERCIAL_REGISTER,
  FUNCTIONARY_ORGANIZATION,
  ONAT_USER,
};
